import MenuOptions from '@/@straico-ui/commons/MenuOptions';
import { getLabelMinutes } from '@/Features/Core/Components/ActiveAttachmentFiles/utils';
import useThemeStore from '@/Theme/store';
import { cn } from '@/utils/styles';
import {
  CheckIcon,
  FolderIcon,
  FolderOpenIcon,
} from '@heroicons/react/24/outline';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/solid';
import { Badge } from '@mui/material';
import { memo } from 'react';
import toast from 'react-hot-toast';

const ActiveAttachmentFiles = ({
  files,
  onFileChange,
  setShowFileDialog,
  messagesCount,
}) => {
  const changeStatus = (file) => {
    onFileChange((prev) =>
      prev.map((f) =>
        f.file === file.file ? { ...file, enabled: !file.enabled } : f
      )
    );
    toast.success(!file.enabled ? 'Enabled attachment' : 'Disable attachment');
  };
  const { theme } = useThemeStore();
  return (
    <>
      {files && files.length > 0 && (
        <MenuOptions
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{
            '& .MuiPaper-root': {
              borderRadius: 2,
              minWidth: (theme) => ({
                xs: 200,
                md: 400,
                lg: 600,
              }),
              py: 1,
              background: (theme) =>
                theme.palette.mode === 'dark' ? '#211E21' : '#FFFFFF',
              color: 'rgb(55, 65, 81)',
              boxShadow:
                'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
              '& .MuiMenu-list': {
                padding: '4px 0',
              },
            },
          }}
          title={
            <div
              className={cn(
                `w-full flex items-center justify-center gap-2 p-1 rounded-r-2xl ${
                  theme === 'light' ? 'bg-white' : 'dark:bg-[#211E21]'
                }`,
                {
                  'rounded-2xl': messagesCount === 0,
                }
              )}
            >
              <Badge
                badgeContent={files.length}
                color="primary"
                className="p-1 w-full"
              >
                <div
                  className={`flex items-center gap-2 text-night-black ${
                    theme === 'light' ? 'text-night-black' : 'text-[#FFFFFF]'
                  }`}
                >
                  {true ? (
                    <FolderIcon
                      className={`h-5 w-5 text-violet-blue ${
                        theme === 'light'
                          ? 'text-violet-blue'
                          : 'text-[#E2E8F0]'
                      }`}
                    />
                  ) : (
                    <FolderOpenIcon
                      className={`h-5 w-5 text-violet-blue ${
                        theme === 'light'
                          ? 'text-violet-blue'
                          : 'text-[#E2E8F0]'
                      }`}
                    />
                  )}
                  {messagesCount === 0 && (
                    <p
                      className={`text-sm font-medium ${
                        theme === 'light'
                          ? 'text-night-black'
                          : 'text-[#E2E8F0]'
                      }`}
                    >
                      attachments
                    </p>
                  )}
                </div>
              </Badge>
            </div>
          }
          customChildren={
            <>
              <div className="flex px-5 justify-center w-full gap-2 flex-col flex-wrap">
                {files.map((file) => (
                  <div key={file.metadata._id} className="w-fit">
                    <div
                      className={cn(
                        `text-violet-blue ml-2 flex-grow flex gap-2 items-center justify-center px-2 py-1 rounded-3xl cursor-pointer ${
                          theme === 'light'
                            ? 'text-violet-blue'
                            : 'text-[#E2E8F0]'
                        }`,
                        {
                          [`bg-ghost-white text-cool-gray ${
                            theme === 'light'
                              ? 'bg-ghost-white text-cool-gray'
                              : 'bg-[#3B3B45] text-cool-gray'
                          }`]: file.enabled === false,
                          [`bg-lavender text-nue-blue ${
                            theme === 'light'
                              ? 'bg-lavender text-nue-blue'
                              : 'bg-[#2D2B2D] text-[#E2E8F0]'
                          }`]: file.enabled === true,
                        }
                      )}
                      onClick={() => changeStatus(file)}
                    >
                      {file.enabled && <CheckIcon className="h-4 w-4" />}
                      <div className="flex items-center gap-2 max-w-[120px] md:max-w-[200px]">
                        <p className="font-medium text-sm truncate">
                          {file.metadata.name}
                        </p>
                        <a
                          href={file.metadata.url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <ArrowTopRightOnSquareIcon className="size-4" />
                        </a>
                      </div>
                      {file.metadata.type === 'youtube' && (
                        <p className="text-xs -mt-1 font-thin">
                          {getLabelMinutes(file.metadata.size)} |{' '}
                          {file.metadata.channel}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </>
          }
        />
      )}
    </>
  );
};

export default memo(ActiveAttachmentFiles);
